<h1 class="bolt-heading-md bolt-serif">Review policies</h1>
<bolt-tabset
  #boltTabGroup
  (bolt-tab-changed)="onTabChange($event)"
  [attr.id]="'reviewPoliciesTabGroup'"
  >
  <bolt-tablabel [attr.id]="'coveragesTab'">Coverages</bolt-tablabel>
  <bolt-tabpanel class="custom-bolt-tab bg-pale-gray">
    <nwx-coverage-display-container
      (editTelematicsClicked)="setTelematicsTabActive()"
    ></nwx-coverage-display-container>
  </bolt-tabpanel>

  <bolt-tablabel [attr.id]="'discountsTab'"
    >Discounts and surcharges</bolt-tablabel
    >
    <bolt-tabpanel class="custom-bolt-tab bg-pale-gray">
      <nwx-discount-display-container></nwx-discount-display-container>
    </bolt-tabpanel>

    @if ((isAutoProductSelected$ | async) && !(isTelematicsDeclined$ | async)) {
      <bolt-tablabel
        [attr.id]="'telematicsTab'"
        >Telematics</bolt-tablabel
        >
      }
      @if ((isAutoProductSelected$ | async) && !(isTelematicsDeclined$ | async)) {
        <bolt-tabpanel class="custom-bolt-tab bg-pale-gray">
          <nwx-telematics-container></nwx-telematics-container>
        </bolt-tabpanel>
      }

      @if ((reportsAndUWApplicable$ | async) || (uwIssuesExist$ | async)) {
        <bolt-tablabel
          [attr.id]="'reportsTab'"
          >
          <div style="display:flex; flex-direction:row; align-items:center">
            @if (uwIssuesExist$ | async) {
              <bolt-icon name="exclamation-circle-filled" color="cherryRed"></bolt-icon>
            }
            <div style="margin-left:0.5em">Reports and underwriting</div>
          </div>
        </bolt-tablabel>
      }
      @if ((reportsAndUWApplicable$ | async) || (uwIssuesExist$ | async)) {
        <bolt-tabpanel
          class="custom-bolt-tab reports bg-pale-gray"
          >
          <nwx-uw-reports (scrollToTasks)="scrollToTasks.emit()"></nwx-uw-reports>
        </bolt-tabpanel>
      }

      @if (evtAlertsExist$ | async) {
        <bolt-tablabel [attr.id]="'alertsTab'">
          <div style="display:flex; flex-direction:row; align-items:center">
            <bolt-icon name="exclamation-circle-filled" color="cherryRed"></bolt-icon>
            <div style="margin-left:0.5em">Alerts</div>
          </div>
        </bolt-tablabel>
        <bolt-tabpanel class="bolt-bolt-tab">
          <nwx-fraud-alert></nwx-fraud-alert>
        </bolt-tabpanel>
      }
    </bolt-tabset>
